import {Classificazione} from '../../../../common/models/classificazione';
import {PraticaLight} from '../../../../common/models/pratica/pratica-light';
import {Step} from './step';
import {Petitum} from '../../../../common/models/petitum';
import {Controparte} from "../../../../common/models/controparte";
import {AltraParte} from "../../../../common/models/altraparte";
import {Atto} from "../../../../common/models/atto";
import {Adempimento} from "../../../../common/models/adempimento";
import {DocumentoAllegato} from "../../../../common/models/documento-allegato";
import {Scadenza} from "../../../../common/models/scadenza";

export class Valore {
  pratica?: PraticaLight;
  classificazione?: {
    classificazioni: Classificazione[]
  };
  petitum:Petitum;
  fascicolo: any;
  controparti: Controparte[];
  altreParti: AltraParte[];
  atti: Atto[];
  adempimenti: Scadenza[];
  documentazioneAllegata: DocumentoAllegato[];

  constructor() {
    this.classificazione.classificazioni = [];
  }
}
export class FascicoloTemp {
  fascicoloTemp: {
    id?: string;
    step: Step;
    valore: Valore;
  }
  idElaborazione?: string;
}
